import { EnrollmentExperienceResponse, SearchToolsRequest, SearchToolsResponse } from "@/api/types";

import { request } from "./request";

/**
 * Gets whitelabel data given a client and optionally a language
 */
export async function getWhitelabelAPI(payload: { client: string; language?: string }): Promise<EnrollmentExperienceResponse> {
  const response = await request<EnrollmentExperienceResponse>({
    url: "/whitelabel/get",
    method: "POST",
    data: {
      client_name: payload.client,
      language_key: payload.language || "en",
    },
  });
  return response as EnrollmentExperienceResponse;
}

/**
 * Gets search tools given coverage strategy ids to compare and optionally a language, as of date, and client name
 */
export async function searchTools(input: SearchToolsRequest): Promise<SearchToolsResponse> {
  const response = await request<SearchToolsResponse>({
    url: "/whitelabel/search_tools",
    method: "POST",
    data: input,
  });
  return response as SearchToolsResponse;
}
